const regions = ['gb', 'de', 'fr', 'es', 'it', 'nl', 'pl', 'se', 'us'];
    
//exchange rates
const exchangeRateMargin = 0.03; //margin the bank charges as we have to take in GBP
const euro = 1.2;
const exchangeRates = {
  gb: 1,
  fr: euro + exchangeRateMargin,
  de: euro + exchangeRateMargin,
  es: euro + exchangeRateMargin,
  it: euro + exchangeRateMargin,
  nl: euro + exchangeRateMargin,
  se: 12.5 + exchangeRateMargin,
  pl: 5.6 + exchangeRateMargin,
  us: 1.4 + exchangeRateMargin,
};


export {regions, exchangeRates}